{
  "list": {
    "title": "Benachrichtigungen"
  },
  "planExport": {
    "download": "Herunterladen",
    "view": "Ansehen",
    "completed": "abgeschlossen",
    "failed": "konnte nicht abgeschlossen werden",
    "inProgress": "ist in Bearbeitung",
    "export": "Export",
    "completedStatus": "Abgeschlossen",
    "failedStatus": "Fehlgeschlagen",
    "inProgressStatus": "Im Gange"
  },
  "markAsRead": "Als gelesen markieren",
  "noNotifications": "Derzeit gibt es keine Benachrichtigungen.",
  "layersImport": {
    "in-progress": {
      "title": "Ebenen importieren",
      "description": "Ebenen importieren: {{ name }}"
    },
    "completed": {
      "title": "Der Import der Ebenen ist abgeschlossen",
      "description": "Ebenen-Import abgeschlossen: {{ name }}"
    },
    "failed": {
      "title": "Ebenen konnten nicht importiert werden",
      "description": "Ebenen konnten nicht importiert werden: {{ name }}"
    },
    "goToMap": "Gehe zur Karte"
  },
  "layersCopy": {
    "in-progress": {
      "title": "Ebenen kopieren",
      "description": "Ebenen kopieren: {{ name }}"
    },
    "completed": {
      "title": "Das Kopieren der Ebenen ist abgeschlossen",
      "description": "Das Kopieren der Ebenen ist abgeschlossen"
    },
    "failed": {
      "title": "Ebenen konnten nicht kopiert werden",
      "description": "Ebenen konnten nicht kopiert werden: {{ name }}"
    },
    "goToMap": "Gehe zur Karte"
  },
  "layersUnlink": {
    "in-progress": {
      "title": "Verknüpfung von Ebenen aufheben",
      "description": "Verknüpfung von Ebenen aufheben: {{ name }}"
    },
    "completed": {
      "title": "Die Verknüpfung der Ebenen wurde aufgehoben",
      "description": "Die Verknüpfung der Ebenen wurde aufgehoben"
    },
    "failed": {
      "title": "Die Verknüpfung der Ebenen konnte nicht aufgehoben werden",
      "description": "Die Verknüpfung der Ebenen konnte nicht aufgehoben werden: {{ name }}"
    },
    "goToMap": "Gehe zur Karte"
  },
  "mapsCopy": {
    "in-progress": {
      "title": "Plan (e) kopieren",
      "description": "Kopieren nach: {{ destinationName }}"
    },
    "completed": {
      "title": "Plan (e) kopieren abgeschlossen",
      "description": "Kopiert nach: {{ destinationName }}"
    },
    "goToLocation": "Gehe zu {{ destinationName }}",
    "teamMapLimitReached": "Das Limit für Teampläne wurde erreicht.",
    "somePlansWereNotCopied": "Einige Pläne wurden nicht kopiert.",
    "somePlansFailedToCopy": "Einige Pläne konnten nicht kopiert werden."
  }
}